<app-common-modal #editAccessoryValueModal [name]="'editAccessoryValueModal'" [title]=" " [twoButtonsDialogs]="true" [withFooter]="false">

  <h4 class="modal-title" modal-title translate>T_OFFER_DATA_MANAGEMENT_ACCESSORY_VALUE_INFORMATION</h4>
  <div modal-body>
    <div *ngIf="availableAccessories">
      <h5 translate>T_ACCESSORY</h5>
      <p-dropdown [(ngModel)]="editAccessoryValueForm.accessoryId" [autoDisplayFirst]="false" [options]="availableAccessories" optionLabel="nameTranslated" optionValue="id" styleClass="dropdown-small"></p-dropdown>
      </div>
    <h5 translate>T_ACCESSORY_REFERENCE</h5>
    <p *ngIf="!editAccessoryValueForm.bslReference">
      <span translate>T_ACCESSORY_NO_REFERENCE</span>
    </p>
    <p *ngIf="editAccessoryValueForm.bslReference">
      <span>{{editAccessoryValueForm.bslReference}}</span>
      <button (click)="clickDeleteReferenceButton()" class="action-button se-icon">action_delete</button>
    </p>
    <button (click)="clickAddReferenceButton()" *ngIf="!editAccessoryValueForm.bslReference"  class="btn btn-smart btn-gray" translate>
      <span class="se-icons">action_add_stroke</span>T_ACCESSORY_REFERENCE_ADD_BUTTON
    </button>
    <h5 translate>T_ACCESSORY_NAME</h5>

    <app-spinner *ngIf="isLoading" [sizeClass]="'medium'" class="spinner"></app-spinner>
    <div *ngIf="!isLoading">
      <div *ngFor="let item of editAccessoryValueForm.value | keyvalue; trackBy: trackByFn" class="edit-accessory-value-name">
        {{item.key}}: <input [(ngModel)]="editAccessoryValueForm.value[item.key]" class="edit-accessory-value-name-input" type="text" />
      </div>
    </div>

    <div class="edit-accessory-value-modal-footer">
      <button (click)="hide()" class="btn btn-default-white-background" translate>T_BUTTON_CANCEL</button>
      <button (click)="clickOnSaveAccessoryValue(); hide()" [disabled]="!isValidForm()" class="btn btn-default-white-background" translate>T_OFFER_DATA_MANAGEMENT_SAVE_ACCESSORY_BUTTON</button>
    </div>
  </div>


</app-common-modal>

<!--Modal add reference-->
<app-odm-add-modal #addReferenceModal
                   (onAddReferenceButton)="addReference($event)"
                   [accessType]="'accessory'"
                   [isOption]="false"
                   [notAllowedReferenceCategories]="notAllowedReferenceCategoriesForAccessories"
                   [selectedRange]="selectedRange">
</app-odm-add-modal>
